import { LinkText } from '@plato/ui-legacy/components/ui/link-text';
import { Text } from '@plato/ui-legacy/components/ui/text';
import React from 'react';
import { useTranslation } from 'react-i18next';

type Props<TItem> = {
    title: string;
    totalCount: number;
    items: TItem[];
    getItemKey: (item: TItem) => string;
    renderItem: (item: TItem) => React.ReactNode;
    onMoreClick: () => void;
    createTitle?: string;
    onCreate?: () => void;
};

function DashboardActivitiesList<TItem>({
    title,
    totalCount,
    items,
    getItemKey,
    renderItem,
    onMoreClick,
    createTitle,
    onCreate,
}: Props<TItem>) {
    const { t } = useTranslation();

    return (
        <div className="overflow-hidden rounded-xl bg-white w-full border border-neutral-100">
            <div className="flex items-center justify-between p-2 bg-cool-gray-50 text-nowrap">
                <div className="flex items-center gap-3">
                    <span className="flex h-6 w-6 items-center justify-center rounded-full bg-cool-gray-200">
                        <Text weight="medium" size="xs" color="neutral-950">
                            {totalCount}
                        </Text>
                    </span>
                    <Text weight="medium" color="neutral-950">
                        {title}
                    </Text>
                </div>
                {totalCount === 0 && createTitle && onCreate ? (
                    <LinkText as="button" onClick={onCreate}>
                        {createTitle}
                    </LinkText>
                ) : (
                    <LinkText as="button" onClick={onMoreClick}>
                        {t('show_all', { ns: 'common' })}
                    </LinkText>
                )}
            </div>
            <div className="w-full overflow-hidden">
                {items.map((item, index) => {
                    return (
                        <React.Fragment key={getItemKey(item)}>
                            {index > 0 && <hr className="border-neutral-100" />}
                            {renderItem(item)}
                        </React.Fragment>
                    );
                })}
            </div>
        </div>
    );
}

export default DashboardActivitiesList;
